import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"
import { useId, useState } from "react"

export default ({}) => {
    const [value, setValue] = useState(0)
    const id = useId()


    return(
        <span className="custom-text-color py-1 px-3 rounded-4 prevent-select" style={{ backgroundColor: "rgb(227 227 227 / 97%)" }} id={id}>
            <Icon icon={faMinus} className="me-3 cursor-pointer" onClick={() => setValue(value > 0 ? value - 1 : 0)} /> 
            { value }
            <Icon icon={faPlus} className="ms-3 cursor-pointer" onClick={() => setValue(value + 1)} />
        </span>
    )
}